import { Button } from "components/DesignSystem/Button/Button";
import { Passkey } from "components/icons/Passkey";
import { usePasskeyRegistration } from "hooks/usePasskeyRegistration";

import { PasskeyNameModal } from "./PasskeyNameModal";

export const AddPasskeyButton = () => {
  const {
    isStarting,
    isSaving,
    isNamingCredential,
    start,
    finishWithName,
    finishWithDefaultName,
  } = usePasskeyRegistration();

  return (
    <>
      <Button
        type="button"
        customType="secondary"
        size="small"
        onClick={start}
        disabled={isStarting}
        isLoading={isStarting}
      >
        Add a Passkey
      </Button>
      <PasskeyNameModal
        open={isNamingCredential}
        title="Name this passkey"
        isSaving={isSaving}
        onSubmit={finishWithName}
        onCancel={finishWithDefaultName}
        secondaryAction={{
          label: "Skip",
          onClick: finishWithDefaultName,
        }}
      />
    </>
  );
};
